import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Lightbulb } from "lucide-react";
import { fetchNiche } from "@/lib/api";
import { ProgramCard } from "@/components/ProgramCard";
import * as Icons from "lucide-react";

export default function NicheDetailPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    window.scrollTo(0, 0);
    fetchNiche(slug).then(setData).catch(console.error);
  }, [slug]);

  if (!data) return <main className="max-w-4xl mx-auto px-4 py-24 text-center text-slate-400">Loading…</main>;

  const Icon = Icons[data.niche.icon] || Icons.Folder;

  return (
    <main data-testid="niche-detail-page" className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
      <Link to="/niches" data-testid="back-to-niches-link" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition-colors duration-200 mb-8">
        <ArrowLeft className="w-4 h-4" /> All niches
      </Link>
      <div className="flex items-start gap-5 mb-8">
        <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4"><Icon className="w-8 h-8 text-emerald-600" strokeWidth={1.8} /></div>
        <div>
          <h1 className="font-heading text-4xl md:text-5xl tracking-tight">{data.niche.name}</h1>
          <p className="text-slate-600 mt-2 max-w-2xl leading-relaxed">{data.niche.description}</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 max-w-lg mb-10">
        {[[data.stats.count, "Programs"], [`$${data.stats.avg_epc}`, "Avg EPC"], [`${data.stats.avg_cookie}d`, "Avg Cookie"]].map(([v, l]) => (
          <div key={l} className="bg-white border border-slate-200 rounded-lg p-5">
            <p className="font-heading text-2xl font-medium">{v}</p>
            <p className="text-xs text-slate-500 uppercase tracking-wider mt-1">{l}</p>
          </div>
        ))}
      </div>

      <div data-testid="niche-insight" className="flex gap-4 bg-emerald-50 border border-emerald-200 rounded-lg p-6 mb-12 max-w-3xl">
        <Lightbulb className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
        <div>
          <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-700 mb-1">Niche Insight</p>
          <p className="text-sm text-slate-700 leading-relaxed">{data.niche.insight}</p>
        </div>
      </div>

      <h2 className="font-heading text-2xl md:text-3xl tracking-tight mb-8">All {data.niche.name} programs</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.programs.map((p) => <ProgramCard key={p.slug} program={p} />)}
      </div>
    </main>
  );
}
